
import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";

@Component
export default class TagSelect extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly value!: string[];
  @Prop({ type: Array, default: () => [] }) readonly options!: string[];
  @Prop({ type: Object, default: () => ({}) }) readonly tagColours!: Record<string, string>;

  get modelValue(): string[] {
    return this.value;
  }

  set modelValue(val: string[]) {
    this.emitInput(val);
  }

  get availableOptions(): string[] {
    return this.options.filter((opt) => !this.modelValue.includes(opt));
  }

  get availableTagColours(): Record<string, string> {
    return Object.fromEntries(this.options.map((tag) => [tag, this.tagColours[tag] || "#5c5e6459"]));
  }

  @Emit("input")
  emitInput(val: string[]): string[] {
    return val;
  }

  @Emit("click-tag")
  clickTag(tag: string): string {
    return tag;
  }
}
